import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/service/language-service/language.service';

type Filters = {
  id?: number; // Opcional
  name: string;
  code: string;
  checked: boolean;
};


@Component({
  selector: 'app-filtro-toogle',
  templateUrl: './filtro-toogle.component.html',
  styleUrls: ['./filtro-toogle.component.scss'],
})
export class FiltroToogleComponent  implements OnInit {
  @Input() filterActive:boolean = false;
  @Input() applyOnlyOneFilter:boolean = false;
  @Input() hasAllOption:boolean = false;
  @Input() filters:Filters[];
  filterSelected = [];

  @Output() filterBy: EventEmitter<any> = new EventEmitter<any>();
  language:string = "es";

  constructor(private languageService: LanguageService,) { }

  ngOnInit() {this.subLanguageConfig();}

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
    });
  }

  onFilterChange(index: number) {
    this.filters[index].checked = !this.filters[index].checked;

    if (this.hasAllOption) {
      const toggledFilter = this.filters[index];
      if (toggledFilter.code === 'all') {
        if (toggledFilter.checked) {
          this.filters.forEach((f, i) => {
            if (i !== index) f.checked = false;
          });
        }
      } else {
        const allFilter = this.filters.find(f => f.code === 'all');
        if (allFilter) allFilter.checked = false;

        const anyNonAllChecked = this.filters.some(f => f.code !== 'all' && f.checked);
        if (!anyNonAllChecked && allFilter) {
          allFilter.checked = true;
        }
      }
    }
  }

  filter() {
    this.filterSelected = [];
		this.filters.forEach(element => {
			if(element.checked){
				this.filterSelected.push(element.code)
			}
		});
    // console.log("aplicar: ",this.filterSelected);
    this.filterBy.emit(this.filterSelected);
  }

  setOnlyOneFilter(index) {
    this.filters.forEach((option, i) => {
      option.checked = i === index ? !option.checked : false;
    });
  }


}
